import { defineStore } from "pinia";
import { useCurationExperienceStore } from "@/features/experience-curation/stores/useCurationExperienceStore";
import { useCurrentExperienceTranslationsQuery } from "@/features/experience-curation/queries/useExperienceTranslationsQuery";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";

export const useCurationSeoDescription = defineStore("curation-content-seo-description-field", () => {
  const curationExperienceStore = useCurationExperienceStore();
  const translationsQuery = useCurrentExperienceTranslationsQuery();

  const initialValue = computed(() => translationsQuery.data.value?.seo_description ?? "");
  const { model, hasChanges, isFilled, reset } = usePrimitiveModelWithChanges(initialValue);

  const isRequired = true;
  const isReadonly = computed(() => curationExperienceStore.isReadonly);

  return {
    id: "seo_description",
    model,
    isRequired,
    isReadonly,
    isFilled,
    hasChanges,
    reset,
  };
});
